import type { i18n as I18n } from 'i18next';

export type ReasonAction = 'return' | 'exchange';

// #96: the label of an item's reason field ("Reason for return"). It is
// composed as `productDetails.reason` + the lowercased action, which no
// translation can make grammatical where nouns are capitalised (de) or where
// the action must be inflected (cs, pl, fi, ...). Such a language gives the
// two full labels `productDetails.reasonFor.return|exchange` (never English,
// see LANGUAGE_ONLY_KEYS); they are read from the language itself only, never
// from the English fallback.
export const reasonLabel = (i18n: I18n, action: ReasonAction): string => {
  const language = i18n.resolvedLanguage || i18n.language;
  const full = i18n.getResource(
    language,
    'translation',
    `productDetails.reasonFor.${action}`
  );
  if (typeof full === 'string' && full.trim() !== '') return full;
  return (
    String(i18n.t('productDetails.reason')) +
    String(i18n.t(`productDetails.${action}`)).toLowerCase()
  );
};
